var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.FontSelector, {
    attrs: { value: _setup.selected, disabled: _vm.disabled },
    on: { input: _setup.onFontSelected },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }